import React from "react"
import { css } from "@emotion/core"
import { Button } from "@cd2/components"
import { IComponentProps } from "@cd2/tools"

interface IProps extends Omit<IComponentProps<typeof Button>, "children" | "onClick" | "disabled"> {
  children?: React.ReactNode
  disabled?: boolean

  onClick?(): void
}

export function CancelButton({ children = "Cancel", onClick, disabled, ...otherProps }: IProps) {
  return (
    <div
      css={css`
        display: inline-block;
      `}
    >
      <Button
        buttonColor="#999"
        buttonStyle="outline"
        color="#666"
        onClick={onClick}
        disabled={disabled}
        {...otherProps}
      >
        {children}
      </Button>
    </div>
  )
}
